import { ServiceErrorCode } from '@/services/utils/service-error';

export const deriveTitleFromErrorCode = (errorCode: ServiceErrorCode) => {
  switch (errorCode) {
    case ServiceErrorCode.AlreadyJoined: // Fallthrough
    case ServiceErrorCode.AlreadyVerified: {
      return "You're all set!";
    }
    case ServiceErrorCode.InvalidToken: {
      return 'You just missed it!';
    }
    case ServiceErrorCode.UnknownAccount: {
      return 'Have we met?';
    }
    case ServiceErrorCode.EmailInviteMismatch: {
      return 'Mismatched email address';
    }
    default: {
      return 'Oh no, something went wrong!';
    }
  }
};
